import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import ReusableDataTable from '../../components/ReusableDataTable';
import NotarialBookDetails from './crud_transaction/transaction_details';
import BackdropModal from '../../components/modals/backdrop_modal';
import apiRequest from '../../services/apiService';
import '../../styles/ReusableDataTable.css';

import TransactionsTable from './crud_transaction/transactions_table';
import LawyerTable from './crud_lawyer/lawyer_table';

const pk = "id";

const columns = [
    // { id: 'id',             field: 'id',            headerName: 'ID' },
    { id: 'fullname',       field: 'fullname',      headerName: 'LAWYER' },
    { id: 'mobile_number',  field: 'mobile_number', headerName: 'CONTACT' },
    { id: 'email',          field: 'email',         headerName: 'EMAIL' },
    // { id: 'region',         field: 'region',        headerName: 'REGION' },
    { id: 'province',       field: 'province',      headerName: 'PROVINCE' },
    { id: 'municipality',   field: 'municipality',  headerName: 'MUN' },
    { id: 'barangay',       field: 'barangay',      headerName: 'BRGY' },
    { id: 'user_status',    field: 'user_status',   headerName: 'STATUS' },
    { id: 'date_created ',  field: 'date_created',  headerName: 'CREATED@' },
];


// List of fields that are date fields
const columns_date = ['date_created'];

// List of fields that has status
const columns_status = ['user_status'];

// List of fields that will Uppercase
const columns_uppercase = ['fullname'];


const actions = [
   // { label: 'Edit', link: './update', icon: 'bx bx-edit-alt me-1' },
];

const other_actions = [
    // { label: 'View', link: '/delete', icon: 'bx bx-detail me-1' },
];



const CACHE_KEY = 'notarialbook_cache_map_lawyer';
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

const generateCacheKey = (params) => {
  return JSON.stringify(params); // You could also hash this if needed
};


const fetchData = async ({ page, rowsPerPage, sortBy, sortOrder, searchTerm, ...filters }) => {


    const queryParams = new URLSearchParams(window.location.search);
  
    const params = {
        page     : parseInt(queryParams.get('page')) ? parseInt(queryParams.get('page')) : 1,
        page_size: rowsPerPage,
        ordering : sortBy ? `${sortOrder === 'desc' ? '-' : ''}${sortBy}`: undefined,
        search   : queryParams.get('searchTerm') ?? (searchTerm || undefined),
        ...filters,
        user_tag:'LAWYER',
    };

    return await apiRequest('GET', '/users/', null, params);
};

const fetchData_old = async ({ page, rowsPerPage, sortBy, sortOrder, searchTerm, filters }) => {
  const params = {
    page,
    page_size: rowsPerPage,
    ordering: sortBy ? `${sortOrder === 'desc' ? '-' : ''}${sortBy}` : undefined,
    search: searchTerm || undefined,
    ...filters,
    user_tag:'LAWYER',
  };

  const cacheKey = generateCacheKey(params);
  const rawCache = localStorage.getItem(CACHE_KEY);
  const cacheMap = rawCache ? JSON.parse(rawCache) : {};

  // Clean expired entries
  const now = Date.now();
  for (const key in cacheMap) {
    if (now - cacheMap[key].timestamp > CACHE_TTL) {
      delete cacheMap[key];
    }
  }

  // Return from cache if available
  if (cacheMap[cacheKey]) {
    console.log('Using cached data for:', cacheKey);
    return cacheMap[cacheKey].data;
  }

  // Fetch and cache
  const response = await apiRequest('GET', '/users/', null, params);
  cacheMap[cacheKey] = {
    timestamp: now,
    data: response,
  };

  localStorage.setItem(CACHE_KEY, JSON.stringify(cacheMap));
  return response;
};



const LawyerNotarialBookTable = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
  
    

    const [filtersState, setFiltersState] = useState({});
    const filters = [
      // { field: 'first_party_full_name', label: 'Name', value: queryParams.get('first_party_full_name') || '', type: 'text' },

      { field: 'date_created', label: 'Date', value: queryParams.get('date') || '', type: 'date' },
      { field: 'gender', label: 'Gender', value: queryParams.get('gender') || '', type: 'select', options: [
          { value: '', label: 'All' },
          { value: 'MALE', label: 'Male' },
          { value: 'FEMALE', label: 'Female' },
        ]
      },
    ];




    const getStatusWithColor = (column, value) => {
        if (columns_status.includes(column)) {
            const statusColors = {
                'VERIFIED'  : 'badge bg-success',
                'NOT_VERIFIED'  : 'badge bg-danger',
                'PENDING'    : 'badge bg-warning',
                'DENIED': 'badge bg-danger',

                'GUEST': 'badge bg-secondary',
            };

         
            const color = statusColors[value?.toUpperCase()] || 'white';
            return (
                <span className={color}>
                    {value}
                </span>
            );
        }
        return value; // For other columns, return the value as is
    };

  const deleteEndpoint = `${process.env.REACT_APP_API_URL}/notarialbook`;
  const [selectedItem, setSelectedItem] = useState(null);

  const handleViewDetails = (item) => {
    console.log(item);
    setSelectedItem(item);
    setOpen(true);
  };

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    handleClose();
  };

  const handleFilterChange = (field, value) => {
    setFiltersState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };


  // const [filterParams, setFilterParams] = useState({});
  // const handleApplyFilters = () => {
  //   setFilterParams(filters.reduce((acc, filter) => {
  //     if (filter.value) {
  //       acc[filter.field] = filter.value;
  //     }
  //     return acc;
  //   }, {}));

  //   filterParams.page = 1; // Reset to the first page when applying filters

  //   const searchParams = new URLSearchParams(filterParams);
  //   console.log(searchParams.toString());
  //   navigate(`?${searchParams.toString()}`);

  //   //fetchData({ page: 1, rowsPerPage: 10, sortBy: null, sortOrder: 'asc', searchTerm: '', filters: filterParams });
  // };

  return (
    <>
      <LawyerTable
        fetchDataFn={fetchData}
        columns={columns}
        columns_date={columns_date}
        columns_uppercase={columns_uppercase}
        actions={actions}
        other_actions={other_actions}
        onViewDetails={handleViewDetails}
        deleteEndpoint={deleteEndpoint}
        tableTitle=''
        primarykey={pk}
        onFilterChange={handleFilterChange}
      

        // WITH STATUS COLORING
        cellStylingFn = {getStatusWithColor}

        filters         = {filters}
        filtersState    = {filtersState}
        setFiltersState = {setFiltersState}
        

  
        hasTableHeader = {false}

      />

      <BackdropModal open={open} handleClose={handleClose} handleSave={handleSave} modalTitle="Notary Details" >
        <NotarialBookDetails selectedItem={selectedItem} />
      </BackdropModal>
    </>
  );
}

export default LawyerNotarialBookTable;